import Box from '@mui/material/Box'
import { KestrixButton, KestrixModal } from '@shared'

import { APP_CHOICES, type AppChoicePath } from '../../utils/navigation'

type AppChooserDialogProps = {
  open: boolean
  onSelect: (path: AppChoicePath) => void
}

/**
 * Asks which app to open. It has no close action, because the only way
 * forward from the login page is to pick an app.
 */
export const AppChooserDialog = ({ open, onSelect }: AppChooserDialogProps) => (
  <KestrixModal
    open={open}
    onClose={() => undefined}
    title="Choose an app"
    subtitle="Select where to go next"
    size="small"
    showCloseButton={false}
    dataTestId="app-chooser-dialog"
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {APP_CHOICES.map(({ path, label }) => (
        <KestrixButton
          key={path}
          variant="default"
          size="large"
          fullWidth
          onClick={() => onSelect(path)}
          data-testid={`app-chooser-option-${path}`}
        >
          {label}
        </KestrixButton>
      ))}
    </Box>
  </KestrixModal>
)
